<template>
  <span class="book-badge" :class="'book-badge--' + info.key" v-b-tooltip.hover :title="info.title">{{ info.short }}</span>
</template>
<script>
  import { bookInfo } from './accountingBook'

  // Etiqueta del libro de un asiento o comprobante: mismo color que el selector de libro.
  export default {
    props: {
      declared: {
        default: null,
      },
    },
    computed: {
      info() {
        return bookInfo(this.declared)
      },
    },
  }
</script>
<style scoped>
  .book-badge {
    display: inline-block;
    min-width: 30px;
    padding: 1px 6px;
    font-size: 11px;
    font-weight: 700;
    text-align: center;
    border-radius: 4px;
    cursor: default;
  }
  .book-badge--d {
    color: var(--app-color-info);
    background: var(--app-color-info-soft);
    border: 1px solid var(--app-color-info-border);
  }
  .book-badge--nd {
    color: var(--app-color-text);
    background: var(--app-color-warning-soft);
    border: 1px solid var(--app-color-warning-border);
  }
  .book-badge--both {
    color: var(--app-color-text-secondary);
    background: var(--app-color-surface-subtle);
    border: 1px solid var(--app-color-border);
  }
</style>
